const sortedObj = (filters) => Object.keys(filters)
  .sort()
  .reduce((acc, key) => {
    acc[key] = filters[key];
    return acc;
  }, {});

function prepareDataForAppliedFilterEvent(activeFiltersList, onlyUnique) {
  const sortedFilters = sortedObj(activeFiltersList);
  const appliedFilters = [];

  Object.entries(sortedFilters).forEach(([filterName, filterData]) => {
    if (!filterData || typeof filterData !== 'object') return;

    const operator = filterData.operator || filterData.filter_operator || '';
    const { value } = filterData;

    if (value === undefined || value === null) return;

    let formattedValue;
    if (Array.isArray(value)) {
      const ids = value.map((v) => {
        if (typeof v === 'object' && v._id) {
          return v._id;
        }
        if (typeof v === 'object' && v.name) {
          return v.name;
        }
        return v;
      });
      formattedValue = ids.slice(0, 5).join(',');
    } else {
      formattedValue = String(value);
    }

    if (onlyUnique) {
      if (Array.isArray(value)) {
        appliedFilters.push(`${filterName}_${operator}_${formattedValue}`);
      }
      return;
    }

    if (Array.isArray(value)) {
      appliedFilters.push(`${filterName}_${operator}`);
    } else {
      appliedFilters.push(`${filterName}_${operator}_${formattedValue}`);
    }
  });

  return appliedFilters;
}

export default prepareDataForAppliedFilterEvent;
